module.exports = __webpack_public_path__ + "assets/img/gz.7fb0c183.jpg";